import { isEmpty } from 'lodash-es';
import { Gender } from './common';
export { RootStateProps } from './common';

export interface Grade {
  id: string;
  label: string;
  code: string;
  slug: string;
  junior: boolean;
}

export interface Organization {
  id: string;
  name: string;
  school_id: string;
}

export interface DepartmentCategory {
  id: string;
  name: string;
  code: `${number}`;
}

export interface College {
  id: string;
  college_id: string;
  name: string;
  name_kana: string;
  prefecture_code: string;
}

export interface CollegeDepartment {
  id: string;
  name: string;
}

export interface PreferredCollege {
  order: number;
  college?: College;
  college_department?: CollegeDepartment;
}

export interface OrganizationMembership {
  id: string;
  amount: number | undefined;
  billing_type: 'student' | 'school' | 'undefined';
  contract_status_key:
    | 'expiration'
    | 'nothing'
    | 'school'
    | 'student_paid'
    | 'student_unpaid';
  end_date: string | undefined;
  verified: boolean;
  organization: Organization;
  code: string | undefined;
  last_name: string | undefined;
  first_name: string | undefined;
  last_name_kana: string | undefined;
  first_name_kana: string | undefined;
  birth_day: number | undefined | null;
  birth_month: number | undefined | null;
  birth_year: number | undefined | null;
  class_name: string | undefined;
  attendance_number: number | undefined;
  grade: Grade | { id?: string };
  // gender: string | undefined; // obsoleted
  // username: string | undefined; // obsoleted
}

export interface SchoolLearner {
  last_name: string;
  first_name: string;
  last_name_kana: string;
  first_name_kana: string;
  birth_year: string;
  birth_month: string;
  birth_day: string;
  gender: Gender;
  gender_expression: string | undefined;
  username: string;
  password: string;
  password_confirmation: string;
  email?: string;
  class_name: string;
  attendance_number: string;
  grade: Grade | undefined;
  high_school: Organization | undefined;
  department_categories_of_interest: DepartmentCategory[];
  colleges: Array<PreferredCollege | null>;
  organization_membership_code: string | undefined;
  inputted_by_parents: boolean;
  consent_to_schools: boolean;
  receive_latest_info: boolean;
  use_organization_membership_code_as_username: boolean;
}

export interface SchoolRootState {
  completion: boolean;
  school_learner: SchoolLearner;
  organization_membership:
    | OrganizationMembership
    | {
        code?: string;
        grade: { id: string | undefined };
        class_name: string | undefined;
        attendance_number: string | undefined;
      };
}

export const isOrganizationMembershipFetched = (
  om: OrganizationMembership | { code?: string } | undefined,
): om is OrganizationMembership => !isEmpty(om) && !!om && !!om.code;
